<template>
    <div class="md-quick-search template2" v-if="filteredList.length > 0">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-if="selectedQuickSearch.title" v-html="formatFontSize(selectedQuickSearch.title, '--mg-title-size')"></div>
            <div class="list">
                <ul :class="{ 'quick-list': true, collapse: collapse }">
                    <li
                        v-for="item in filteredList"
                        :key="item.id"
                        class="quick-search-item"
                        :class="{ hot: item.hot }"
                    >
                        <a
                            v-if="item.type != 'link'"
                            :href="item.href"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span
                                v-if="item.hot"
                                class="hot-search iconfont icon-bookmark-star"
                            ></span>
                            <Count
                                :max="mlsCount"
                                :count="
                                    countMap[item.key] === undefined
                                        ? -1
                                        : countMap[item.key]
                                "
                            />
                        </a>
                        <a
                            v-else
                            :href="item.url"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span
                                v-if="item.hot"
                                class="hot-search iconfont icon-bookmark-star"
                            ></span>
                        </a>
                    </li>
                </ul>
                <div
                    v-if="showmore"
                    class="quicksearch-more"
                    @click="toggleShowMore"
                >
                    <i class="iconfont icon-arrow-down light"></i>
                    <i class="iconfont icon-arrow-down drak"></i>
                </div>
            </div>
        </module-box>
    </div>
</template>
<script>
import common from '../index';
export default {
    ...common
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-quick-search.template2 {
    .list {
        overflow: hidden;
        font-family: var(--font-bold);
        .quick-list {
            width: 100%;
            overflow: hidden;
            margin-top: -10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li {
                width: 30%;
                overflow: hidden;
                position: relative;
                box-sizing: content-box;
                padding: 10px 0;
                vertical-align: middle;
                a {
                    display: flex;
                    align-items: center;
                    height: 100%;
                }
                .search-title {
                    font-size: 15px;
                    text-align: left;
                    display: inline-block;
                    @include ellipsis();
                    max-width: calc(100% - 65px);
                    color: #505050;
                    border-bottom: 2px solid transparent;
                    &.hot {
                        max-width: calc(100% - 100px);
                    }
                    &:hover {
                        @include color-theme();
                        @include color-theme('border-color');
                    }
                }
                .hot-search {
                    display: inline-block;
                    margin-left: 5px;
                    font-size: 18px;
                    color: #ffb324;
                }
                .num {
                    margin-left: auto;
                    height: 17px;
                    line-height: 17px;
                    padding: 0 5px;
                    font-size: 14px;
                    color: #787878;
                    &:before {
                        content: '(';
                    }
                    &:after {
                        content: ')';
                    }
                }
                &:nth-child(3n + 1) {
                    margin-left: 0;
                }
            }
            &:after {
                content: '';
                width: 30%;
            }
        }
        .quicksearch-more {
            display: none;
        }
    }

    @include media-1080 {
        .list {
            .quick-list {
                li {
                    width: 48%;
                }
            }
        }
    }

    @include media-600 {
        .list {
            .quick-list {
                width: 100%;
                margin-right: 0;
                margin-top: 0;
                margin-bottom: 0;
                border-top: 1px solid #dcdcdc;
                li {
                    // box-sizing: border-box;
                    width: 100%;
                    display: block;
                    margin-left: 0;
                    &:after {
                        display: none;
                    }
                    .num {
                        right: 0;
                        font-size: 14px;
                    }
                }
                &.collapse {
                    overflow: hidden;
                    & + .quicksearch-more {
                        transform: rotate(0);
                    }
                    li {
                        display: none;
                        &:nth-child(-n + 5) {
                            display: block;
                        }
                    }
                }
            }
            .quicksearch-more {
                display: block;
                height: 30px;
                width: 30px;
                cursor: pointer;
                margin: 10px auto;
                position: relative;
                transform: rotate(180deg);
                .iconfont {
                    font-size: 22px;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                }
                .light {
                    color: #c3c3c3;
                    top: 10px;
                }
                .drak {
                    color: #7e7e7e;
                    top: 0;
                }
            }
        }
    }
}
</style>
